module.exports = __webpack_public_path__ + "img/404.15f9973e.png";